import { render, staticRenderFns } from "./AdmissionMajorFormSave.vue?vue&type=template&id=bbdbe460&scoped=true&"
import script from "./AdmissionMajorFormSave.vue?vue&type=script&lang=js&"
export * from "./AdmissionMajorFormSave.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionMajorFormSave.vue?vue&type=style&index=0&id=bbdbe460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdbe460",
  null
  
)

export default component.exports